import * as constants from './PlvLiveLogin.constants';
import * as services from './PlvLiveLogin.service';

const state = {
  plvWatchLink: {},
};

const mutations = {
  [constants.GET_PLV_WATCH_LINK_SUCCESS](state, plvWatchLink) {
    if (undefined !== plvWatchLink && null !== plvWatchLink) {
      state.plvWatchLink = plvWatchLink;
    }
  },
};

const actions = {
  async getPlvWatchLink({ commit, dispatch }, payload) {
    const res = await services.getPlvWatchLink(payload);
    if (500 === res.data.status) {
      dispatch('logoutFromData', null, { root: true });
    } else {
      commit(constants.GET_PLV_WATCH_LINK_SUCCESS, res.data.data);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
